import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = {
    key: 0,
    class: "form-menu"
};
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add Manufacturer", -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add Battery Monitor Model", -1 /* HOISTED */);
const _hoisted_10 = { class: "form-contents" };
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "clearfix" };
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_14 = { class: "input-group top_search" };
const _hoisted_15 = { class: "input-group-btn" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-5"
};
const _hoisted_19 = { class: "input-group top_search" };
const _hoisted_20 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_21 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_22 = { class: "float-end left5" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* HOISTED */);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix top10" }, [
    /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_25 = { class: "clearfix pad10" };
const _hoisted_26 = { class: "float-end" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_28 = {
    key: 0,
    class: "float-end"
};
const _hoisted_29 = { class: "float-end hidden-xs record-count" };
const _hoisted_30 = { class: "clearfix" };
const _hoisted_31 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_32 = {
    class: "nav nav-tabs",
    role: "tablist"
};
const _hoisted_33 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-battery-full" }, null, -1 /* HOISTED */);
const _hoisted_35 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-plug" }, null, -1 /* HOISTED */);
const _hoisted_37 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-microchip" }, null, -1 /* HOISTED */);
const _hoisted_39 = { class: "col-xs-12 col-sm-12" };
const _hoisted_40 = { class: "card bg-white data-grid manufacturers-grid detached overflow-x-auto top0" };
const _hoisted_41 = { class: "table table-hover bottom0 pw100" };
const _hoisted_42 = {
    key: 0,
    class: "text-center hidden-sm w40 no-min-width"
};
const _hoisted_43 = { class: "text-center hidden-sm" };
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_46 = { key: 0 };
const _hoisted_47 = { key: 0 };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "2"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_49 = [
    _hoisted_48
];
const _hoisted_50 = { class: "col-xs-12 col-sm-12" };
const _hoisted_51 = { class: "card bg-white data-grid manufacturers-grid detached overflow-x-auto top0" };
const _hoisted_52 = { class: "table table-hover bottom0 pw100" };
const _hoisted_53 = {
    key: 0,
    class: "text-center hidden-sm w40 no-min-width"
};
const _hoisted_54 = { class: "text-center hidden-sm" };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_57 = { key: 0 };
const _hoisted_58 = { key: 0 };
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "2"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_60 = [
    _hoisted_59
];
const _hoisted_61 = { class: "col-xs-12 col-sm-12" };
const _hoisted_62 = { class: "card bg-white data-grid models-grid detached overflow-x-auto top0" };
const _hoisted_63 = { class: "table table-hover bottom0 pw100" };
const _hoisted_64 = {
    key: 0,
    class: "text-center hidden-sm w40 no-min-width"
};
const _hoisted_65 = { class: "text-center hidden-sm" };
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_67 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_68 = { key: 0 };
const _hoisted_69 = { class: "clearfix visible-sm" };
const _hoisted_70 = { key: 0 };
const _hoisted_71 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "2"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no controller models matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_72 = [
    _hoisted_71
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle), 1 /* TEXT */)
            ]),
            _createTextVNode(),
            (_ctx.query.companyId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (_ctx.viewMode !== 'batteryMonitor')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: 'manufacturer', params: { 'companyId': _ctx.query.companyId }, query: { manufacturerTypeId: _ctx.currentManufacturerTypeId } }
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_b_button, { variant: "primary" }, {
                                        default: _withCtx(() => [
                                            _hoisted_6,
                                            _hoisted_7
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["to"]))
                            : _createCommentVNode("v-if", true),
                        _createTextVNode(),
                        (_ctx.viewMode === 'batteryMonitor')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: { name: 'model', params: { 'companyId': _ctx.query.companyId, 'manufacturerId': 0 } }
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_b_button, { variant: "primary" }, {
                                        default: _withCtx(() => [
                                            _hoisted_8,
                                            _hoisted_9
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["to"]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.currentQuery.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.currentQuery.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _createTextVNode(),
                            _createElementVNode("span", _hoisted_15, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, _hoisted_17)
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.companies.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.company,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.company) = $event)),
                                    options: _ctx.companies,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Select a Company",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    _createElementVNode("div", {
                        class: _normalizeClass(['col-xs-12 col-sm-12', _ctx.companies.length > 1 ? 'col-md-3' : 'col-md-8'])
                    }, [
                        (_ctx.searchAttempted)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                        _createVNode(_component_b_dropdown, {
                                            ref: "columnSettingsDropdown",
                                            "no-caret": "",
                                            end: "",
                                            sm: "",
                                            "auto-close": false,
                                            variant: "outline-secondary outline-secondary-pagination",
                                            disabled: _ctx.working
                                        }, {
                                            "button-content": _withCtx(() => [
                                                _hoisted_23
                                            ]),
                                            default: _withCtx(() => [
                                                _createTextVNode(),
                                                _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_24,
                                                        _createTextVNode(),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentColumns, (column, columnIdx) => {
                                                            return (_openBlock(), _createBlock(_component_b_form_group, {
                                                                key: column.fieldName
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_group, null, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_b_form_checkbox, {
                                                                                id: column.fieldName,
                                                                                modelValue: column.visible,
                                                                                "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _createTextVNode(),
                                                _createVNode(_component_b_dropdown_divider),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_25, [
                                                    _createElementVNode("div", _hoisted_26, [
                                                        _createVNode(_component_b_button, {
                                                            variant: "secondary",
                                                            right: "",
                                                            sm: "",
                                                            onClick: _ctx.closeColumnSettingsMenu
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _hoisted_27,
                                                                _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"])
                                                    ])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"])
                                    ]),
                                    _createTextVNode(),
                                    (_ctx.numberOfVisibleColumns)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                            _createVNode(_component_b_pagination, {
                                                class: "float-end",
                                                modelValue: _ctx.currentQuery.pageNo,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.currentQuery.pageNo) = $event)),
                                                "per-page": _ctx.currentQuery.pageSize,
                                                "total-rows": _ctx.currentData.recordCount,
                                                "hide-ellipsis": true,
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_29, "\r\n\t\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.currentData.recordCount), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("ul", _hoisted_32, [
                            _createElementVNode("li", _hoisted_33, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["nav-link", { active: _ctx.viewMode === 'battery' }]),
                                    onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.viewMode = 'battery')),
                                    type: "button",
                                    role: "tab"
                                }, [
                                    _hoisted_34,
                                    _createTextVNode(" Battery\r\n\t\t\t\t\t\t\t\t")
                                ], 2 /* CLASS */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("li", _hoisted_35, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["nav-link", { active: _ctx.viewMode === 'upsCharger' }]),
                                    onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.viewMode = 'upsCharger')),
                                    type: "button",
                                    role: "tab"
                                }, [
                                    _hoisted_36,
                                    _createTextVNode(" UPS/Charger\r\n\t\t\t\t\t\t\t\t")
                                ], 2 /* CLASS */)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("li", _hoisted_37, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["nav-link", { active: _ctx.viewMode === 'batteryMonitor' }]),
                                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.viewMode = 'batteryMonitor')),
                                    type: "button",
                                    role: "tab"
                                }, [
                                    _hoisted_38,
                                    _createTextVNode(" Battery Monitor\r\n\t\t\t\t\t\t\t\t")
                                ], 2 /* CLASS */)
                            ])
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createCommentVNode(" Battery Manufacturers Table "),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("table", _hoisted_41, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisible('ManufacturerName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_42))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'ManufacturerName', title: 'Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manufacturersData.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_43, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_44,
                                                                    _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.deleteManufacturer(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_45,
                                                                    _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.isVisible('ManufacturerName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_46, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'manufacturer', params: { 'companyId': _ctx.query.companyId, 'id': item.manufacturerId }, query: { manufacturerTypeId: item.manufacturerTypeId } },
                                                    class: "blue"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.manufacturerName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_47, _hoisted_49))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted && _ctx.viewMode === 'battery']
                ]),
                _createTextVNode(),
                _createCommentVNode(" UPS/Charger Manufacturers Table "),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("table", _hoisted_52, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisible('ManufacturerName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_53))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'ManufacturerName', title: 'Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manufacturersData.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_54, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_55,
                                                                    _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.deleteManufacturer(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_56,
                                                                    _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.isVisible('ManufacturerName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_57, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'manufacturer', params: { 'companyId': _ctx.query.companyId, 'id': item.manufacturerId }, query: { manufacturerTypeId: item.manufacturerTypeId } },
                                                    class: "blue"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.manufacturerName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_58, _hoisted_60))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted && _ctx.viewMode === 'upsCharger']
                ]),
                _createTextVNode(),
                _createCommentVNode(" Battery Monitor (Controller Models) Table "),
                _createTextVNode(),
                _withDirectives(_createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("table", _hoisted_63, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisibleModel('ModelName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_64))
                                        : _createCommentVNode("v-if", true),
                                    _createTextVNode(),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.modelsSorter,
                                            column: { fieldName: 'ModelName', title: 'Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelsData.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_65, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.editModel(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.editModel(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_66,
                                                                    _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _createTextVNode(),
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.deleteModel(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _hoisted_67,
                                                                    _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _createTextVNode(),
                                        (_ctx.isVisibleModel('ModelName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_68, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'model', params: { 'companyId': _ctx.query.companyId, 'manufacturerId': 0, 'id': item.modelId } },
                                                    class: "blue hidden-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.modelName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                _createTextVNode(),
                                                _createElementVNode("div", _hoisted_69, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'model', params: { 'companyId': _ctx.query.companyId, 'manufacturerId': 0, 'id': item.modelId } },
                                                        class: "lead"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(item.modelName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noModelsData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_70, _hoisted_72))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted && _ctx.viewMode === 'batteryMonitor']
                ])
            ])
        ])
    ]));
}
